import type { FC } from 'react';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '@root/src/stores';
import { pushFlocktoryCartToDataLayer } from '@utils/flocktory/dataLayer/pushUserCart';
import { syncFlocktoryUserLoyaltyDataLayer } from '@utils/flocktory/dataLayer/syncUserLoyalty';
import { syncFlocktoryUserOrdersDataLayer } from '@utils/flocktory/dataLayer/syncUserOrders';

const FlocktoryDataLayer: FC = observer(() => {
  const { userStore, cartStore } = useStores();
  const { isUserLoggedIn, isUserLoading, isLoad, user } = userStore;
  const { cartItemsCount, isLoadCart } = cartStore;

  useEffect(() => {
    if (!isLoad || isUserLoading) {
      return;
    }

    syncFlocktoryUserOrdersDataLayer(isUserLoggedIn, user?.email);
    syncFlocktoryUserLoyaltyDataLayer(isUserLoggedIn);
  }, [isLoad, isUserLoading, isUserLoggedIn, user?.email]);

  useEffect(() => {
    if (!isLoadCart) {
      return;
    }

    pushFlocktoryCartToDataLayer(cartItemsCount);
  }, [isLoadCart, cartItemsCount]);

  return null;
});

export default FlocktoryDataLayer;
